import { Checkbox, Space } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getPANFundMedications } from '../SpecialRules/PANSpecialRules';
import './RadioInputStyle.css';

//import { Checkbox } from 'antd';
const PANFundMedications = props => {
    const { def, data, onChange, state } = props;
    const { getThenResolver } = props;
    const [fundMeds, setFundMeds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFundMeds() {
            const meds = await getPANFundMedications(getThenResolver, ctx.meta.assistanceProgramId);
            setFundMeds(meds);
        };

        loadFundMeds();
    }, []);

    const selectedFund = ctx.formData['PAN Fund Selection'];

    if (!fundMeds || !selectedFund) return null;

    return <Checkbox.Group
        value={data}
        onChange={(values => onChange(def.dataKey, values))}
        data-input={'panfundmedicationsinput_de'}
    >
        <Space direction='vertical'>
            {fundMeds.find(f => f.fundName === selectedFund)?.medications.map((med) => {
                const label = med.name;
                const val = med.value;

                return <Checkbox value={val} style={{ color: 'black !important' }}>{label}</Checkbox>
            })}
        </Space>
    </Checkbox.Group>
}

export default WithDataFetcher(PANFundMedications);
